import FloorInstallationInformation from './FloorInstallationInformation';

export default FloorInstallationInformation;